/**
 * Business days are calendar dates (YYYY-MM-DD) in the OUTLET's time zone, not the browser's: an
 * owner in Jakarta looking at a Makassar outlet still sees that outlet's "today" (DATA_MODEL C11).
 */
export function dayIn(timeZone: string, at: Date = new Date()): string {
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(at)
}

export function addDays(day: string, n: number): string {
  const d = new Date(`${day}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + n)
  return d.toISOString().slice(0, 10)
}

export type RangeKey = 'today' | 'yesterday' | 'last7' | 'month'

export function rangeFor(key: RangeKey, today: string): { from: string; to: string } {
  switch (key) {
    case 'today':
      return { from: today, to: today }
    case 'yesterday':
      return { from: addDays(today, -1), to: addDays(today, -1) }
    case 'last7':
      return { from: addDays(today, -6), to: today }
    case 'month':
      return { from: `${today.slice(0, 8)}01`, to: today }
  }
}

const dayFormat = new Intl.DateTimeFormat('id-ID', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' })

/** "Sen, 12 Okt" for a business day. */
export function formatDay(day: string): string {
  return dayFormat.format(new Date(`${day}T00:00:00Z`))
}

/** The phone's own wall-clock time of a sale: its UTC instant plus the offset it recorded. */
export function phoneTime(utcIso: string, offsetMinutes: number): string {
  const t = new Date(new Date(utcIso).getTime() + offsetMinutes * 60_000)
  const hh = String(t.getUTCHours()).padStart(2, '0')
  const mm = String(t.getUTCMinutes()).padStart(2, '0')
  return `${hh}:${mm}`
}
